var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4941 11.4951V9.08887C14.4941 8.26835 14.1682 7.48145 13.588 6.90126C13.0078 6.32107 12.2209 5.99512 11.4004 5.99512H10.0254C9.75189 5.99512 9.48958 5.88647 9.29619 5.69307C9.10279 5.49967 8.99414 5.23737 8.99414 4.96387V3.58887C8.99414 2.76835 8.66819 1.98145 8.088 1.40126C7.50781 0.821065 6.7209 0.495117 5.90039 0.495117H4.18164M7.61914 8.74512V14.2451M10.3691 11.4951H4.86914M6.24414 0.495117H1.77539C1.20614 0.495117 0.744141 0.957117 0.744141 1.52637V17.3389C0.744141 17.9081 1.20614 18.3701 1.77539 18.3701H13.4629C14.0321 18.3701 14.4941 17.9081 14.4941 17.3389V8.74512C14.4941 6.55708 13.6249 4.45866 12.0778 2.91149C10.5306 1.36431 8.43218 0.495117 6.24414 0.495117Z",
    stroke: "#CE1111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.57816577f1eb354d11e1fdb788701f6e.svg";
export { ForwardRef as ReactComponent };